import { SaveHelp, GetHelp, GetHelpTypes, GetHelpDetails } from '@/api/help'
export default {
  state: {},
  actions: {
    SaveHelp ({ commit }, payload) {
      return new Promise(resolve => {
        SaveHelp(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetHelp ({ commit }, payload) {
      return new Promise(resolve => {
        GetHelp(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetHelpTypes ({ commit }, payload) {
      return new Promise(resolve => {
        GetHelpTypes(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetHelpDetails ({ commit }, payload) {
      return new Promise(resolve => {
        GetHelpDetails(payload).then(res => {
          resolve(res.data)
        })
      })
    }
  },
  getters: {},
  mutations: {}
}
